import { render, staticRenderFns } from "./ManageFoodType.vue?vue&type=template&id=ab9c833e&scoped=true&"
import script from "./ManageFoodType.vue?vue&type=script&lang=js&"
export * from "./ManageFoodType.vue?vue&type=script&lang=js&"
import style0 from "./ManageFoodType.vue?vue&type=style&index=0&id=ab9c833e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9c833e",
  null
  
)

export default component.exports